import { dateFormatter2 } from "../Wrapper/CommonFun";


export const REPORTSERVERTIME = {
  "Delivery Content": 0.0104,
  "Batch Summary": 0.0553,
  "Delivery Advance": 0.457,
  "Batch Aborted": 0.0553,
  Aggregator: 0.3724,
  "Delivery Summary": 9.423,
  "Performance Route": 0.8645,
  "Performance User": 0.123,
  Schedule: 0.08,
};


export const sizesArray = ["B", "kB", "MB", "GB", "TB", "PB"];


/** CSS vars (set in common.scss) so RDT follows light/dark without per-page theme props. */
const rdtThemeStyles = {
  table: {
    style: {
      backgroundColor: "var(--rdt-bg)",
      color: "var(--rdt-text)",
    },
  },
  tableWrapper: {
    style: {
      backgroundColor: "var(--rdt-bg)",
    },
  },
  headRow: {
    style: {
      backgroundColor: "var(--rdt-head-bg)",
      color: "var(--rdt-head-text)",
      borderBottomColor: "var(--rdt-border)",
    },
  },
  headCells: {
    style: {
      color: "var(--rdt-head-text)",
    },
  },
  rows: {
    style: {
      backgroundColor: "var(--rdt-bg)",
      color: "var(--rdt-text)",
      borderBottomColor: "var(--rdt-border)",
    },
    highlightOnHoverStyle: {
      backgroundColor: "var(--rdt-row-hover)",
      color: "var(--rdt-text)",
      borderBottomColor: "var(--rdt-border)",
      outlineColor: "var(--rdt-bg)",
    },
  },
  cells: {
    style: {
      color: "var(--rdt-text)",
    },
  },
  noData: {
    style: {
      backgroundColor: "var(--rdt-bg)",
      color: "var(--rdt-text)",
    },
  },
  progress: {
    style: {
      backgroundColor: "var(--rdt-bg)",
      color: "var(--rdt-text)",
      display: "block",
      width: "100%",
      minWidth: "100%",
      padding: 0,
      margin: 0,
    },
  },
};

export const tableCustomStyles = (config) => {
  let { height, minHeight, maxHeight, overflow, fontSize, headFontSize } =
    config ?? {};
  let { tableStyle, wrapperStyle } = config ?? {};

  return {
    table: {
      style: {
        ...rdtThemeStyles.table.style,
        height: height ?? `calc(100vh - 310px)`,
        minHeight: minHeight ?? 400,
        ...(maxHeight ? { maxHeight } : {}),
        overflow: overflow ?? `hidden auto`,
        ...(tableStyle ?? {}),
      },
    },
    tableWrapper: {
      style: {
        ...rdtThemeStyles.tableWrapper.style,
        height: height ?? `calc(100vh - 310px)`,
        minHeight: minHeight ?? 400,
        ...(maxHeight ? { maxHeight } : {}),
        overflow: overflow ?? `auto`,
        ...(wrapperStyle ?? {}),
      },
    },
    headRow: rdtThemeStyles.headRow,
    headCells: {
      style: {
        ...rdtThemeStyles.headCells.style,
        fontSize: `${headFontSize ?? 14}px`,
      },
    },
    rows: rdtThemeStyles.rows,
    cells: {
      style: {
        ...rdtThemeStyles.cells.style,
        fontSize: `${fontSize ?? 12}px`,
      },
    },
    noData: rdtThemeStyles.noData,
    progress: rdtThemeStyles.progress,
  };
};

/** Outer wrapper (.message-table-wrapper, etc.) owns scroll; keep RDT overflow visible for tooltips/dropdowns. */
export const outerScrollTableCustomStyles = () =>
  tableCustomStyles({
    height: "auto",
    maxHeight: "none",
    minHeight: 0,
    overflow: "visible",
    wrapperStyle: {
      overflow: "visible",
      height: "auto",
      maxHeight: "none",
      minHeight: 0,
    },
    tableStyle: {
      overflow: "visible",
      height: "auto",
      maxHeight: "none",
      minHeight: 0,
    },
  });

/** Columns share the full table width equally (use with grow: 1 on data columns). */
export const fullWidthTableCustomStyles = (config) => {
  const base = outerScrollTableCustomStyles();
  const cellPadding = {
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 12,
    paddingRight: 12,
  };

  return {
    ...base,
    table: {
      style: {
        ...base.table?.style,
        width: "100%",
        ...(config?.tableStyle ?? {}),
      },
    },
    headRow: {
      style: {
        width: "100%",
        minWidth: "100%",
      },
    },
    rows: {
      style: {
        width: "100%",
        minWidth: "100%",
      },
    },
    headCells: {
      style: {
        ...base.headCells?.style,
        ...cellPadding,
        fontWeight: 600,
        whiteSpace: "nowrap",
        lineHeight: "1.4",
        justifyContent: "flex-start",
        textAlign: "left",
        flex: "1 1 0",
        minWidth: 0,
      },
    },
    cells: {
      style: {
        ...base.cells?.style,
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 12,
        paddingRight: 12,
        lineHeight: "1.4",
        justifyContent: "flex-start",
        textAlign: "left",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        flex: "1 1 0",
        minWidth: 0,
      },
    },
  };
};


export const getDatesFromDay = (day) => {
  let eDate = new Date();
  let sDate = new Date();

  const dayCount = +day === 30 || +day === 31 ? 31 : +day;

  if (dayCount > 1) {
    sDate.setDate(sDate.getDate() - dayCount + 1);
  } else if (dayCount === 1) {
    sDate.setDate(sDate.getDate() - 1);
    eDate.setDate(eDate.getDate() - 1);
  }

  return {
    startDate: dateFormatter2(sDate).split(" ")[0],
    endDate: dateFormatter2(eDate).split(" ")[0],
  };
};


export const getValidSelectedIds = (
  selectedRows,
  userListDataOrSearchVal = "",
  searchVal = ""
) => {
  const userListData =
    userListDataOrSearchVal &&
    typeof userListDataOrSearchVal === "object" &&
    !Array.isArray(userListDataOrSearchVal)
      ? userListDataOrSearchVal
      : null;
  const effectiveSearchVal =
    typeof userListDataOrSearchVal === "string"
      ? userListDataOrSearchVal
      : searchVal;

  if (!selectedRows) {
    return { ids: [], isAllSelected: false, isSearchMode: false };
  }

  if (selectedRows._searchSelected === true) {
    const searchIds = selectedRows._selectedIds || [];
    return {
      ids: searchIds,
      isAllSelected: false,
      isSearchMode: true,
      searchTerm: selectedRows._searchTerm,
    };
  }

  if (selectedRows._allSelected === true && !selectedRows._isSearchMode) {
    return {
      ids: "ALL",
      isAllSelected: true,
      isSearchMode: false,
    };
  }

  if (selectedRows?.all === true && !selectedRows?.allInSearch) {
    return {
      ids: "ALL",
      isAllSelected: true,
      isSearchMode: false,
    };
  }

  if (selectedRows?.allInSearch === true) {
    const searchIds =
      userListData?.data?.map((row) => row?.id).filter(Boolean) || [];
    return {
      ids: searchIds,
      isAllSelected: false,
      isSearchMode: true,
      searchTerm: effectiveSearchVal || undefined,
    };
  }

  if (Array.isArray(selectedRows)) {
    const validIds = selectedRows
      .filter((id) => {
        const isValid =
          id !== null && id !== undefined && id !== "" && !isNaN(Number(id));
        if (!isValid) {
          console.warn("⚠️ Invalid ID filtered out:", id);
        }
        return isValid;
      })
      .map((id) => Number(id));

    return {
      ids: validIds,
      isAllSelected: false,
      isSearchMode: false,
    };
  }

  console.warn(
    "❌ Unexpected selectedRows format:",
    typeof selectedRows,
    selectedRows
  );
  return { ids: [], isAllSelected: false, isSearchMode: false };
};
export const statusMap = {
  PENDING: "PENDING",
  QUEUED: "QUEUED",
  Q: "QUEUED",
  ATES: "ATES",
  CAAS: "CAAS",
  C: "CAAS",
  HLR: "HLR",
  H: "HLR",
  DELIVRD: "DELIVRD",
  UNDELIV: "UNDELIV",
  REJECTED: "REJECTED",
  RJ: "REJECTED",
  ACCEPTD: "ACCEPTD",
  ERROR: "ERROR",
  BLOCKED: "BLOCKED",
  UN_PROCESSED: "UN_PROCESSED",
  UN: "UN_PROCESSED",
  ZERO_COST: "ZERO_COST",
  EXPIRED: "EXPIRED",
  NR: "NON RESPOND",
  ERR_RESPOND: "ERR_RESPOND",
  MINCOST: "MINCOST",
  M: "MINCOST"
};
